import Tooltip from './tooltip';

import './style/index';
export default Tooltip;



